module.exports = __webpack_public_path__ + "static/img/cs1.9f0691c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/cs1.jpg
// module id = KZa3
// module chunks = 11